import React, { useState } from 'react';
import defaultImage from "../../assets/stairsandbucketswide.png"
import ShareLinkModal from './ShareLinkModal';
import ThreeCardRow from './ThreeCardRow';
import SmallCard from './SmallCard';
import { ShareIcon } from '@heroicons/react/24/solid';

const SendableCourseCard = (props) => {
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const image = props.image !== undefined ? props.image : defaultImage;

  return (
    <div className=" rounded overflow-hidden">
      {image && <img className="w-full" src={image} alt="Card Image" />}
      <div className="px-6 py-4">
        <div className="font-bold text-5xl mb-2">{props.title}</div>
        <button
          onClick={() => setIsShareModalOpen(true)}
          className="flex flex-row items-center bg-green-600 text-gray-200 py-2 px-4 rounded-md hover:bg-green-700 focus:outline-none focus:border-green-700 my-6"
        >
          <ShareIcon className='h-5 mr-2' />
          Share
        </button>
        <ShareLinkModal
          isOpen={isShareModalOpen}
          onClose={() => setIsShareModalOpen(false)}
        />
        <div className="font-semibold text-2xl mb-2">Description</div>
        {props.paragraphs.map((each, key) => {
          return <div key={key}>
            <p className="text-gray-700 text-base">
              {each}
              <br />
              <br />
            </p>
          </div>
        })}
        <div className="font-semibold text-2xl mb-2">Video Usage</div>
        <ThreeCardRow>
          <SmallCard title="In the Office" description="Select 'Office View' to show the video to clients in person." />
          <SmallCard title="Virtual" description="After sending to clients, you can track how many videos have been watched!" />
          <SmallCard title="Track Progress" description="Analytics for you and your team." />
          <SmallCard title="Overview" description={props.overviewDescription || "Stairs & Buckets helps you sell life insurance premium."} />
        </ThreeCardRow>

      </div>
    </div>
  );
};

export default SendableCourseCard;